import { ShoppingCartThemeModeConfig } from './types';

const dark: ShoppingCartThemeModeConfig = {
  shoppingCart: {
    normalButtonBGColor: '#505251',
    normalButtonBorderColor: '2px solid #267DAC',
  },
};

export default dark;
